import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./styles/variables.css";
import "./styles/global.css";
import "./styles/animations.css";
import "./styles/components.css";
import "./styles/screens.css";
import "./styles/desktop.css";

import App from "./App";
import { WalletProvider } from "./context/WalletContext";
import { ToastProvider } from "./components/common/ToastContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <WalletProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </WalletProvider>
  </BrowserRouter>
);
